import React from 'react';
import { ServicesSection } from '../components/ServicesSection';
export function ProductsPage() {
  return <div className="pt-28" data-id="element-499">
      <ServicesSection data-id="element-500" />
    </div>;
}